import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';

export interface AdminLocationRow {
  id: string;
  branch?: string;
  name?: string;
  way_vendor_location_id?: string | null;
}

export interface WaySettingsPayload {
  way_vendor_location_id: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class LocationSettingsService {
  private readonly apiService = inject(ApiService);

  private locationPath(companyId: string, locationId?: string): string {
    const base = `admin/super-admin/companies/${companyId}/locations`;
    return locationId ? `${base}/${locationId}` : base;
  }

  listLocations(companyId: string): Observable<ApiResponse<AdminLocationRow[]>> {
    return this.apiService
      .getWithSuperAdminToken<AdminLocationRow[]>(this.locationPath(companyId), { limit: 1000 })
      .pipe(catchError(error => throwError(() => error)));
  }

  updateWaySettings(
    companyId: string,
    locationId: string,
    payload: WaySettingsPayload
  ): Observable<ApiResponse<AdminLocationRow>> {
    return this.apiService
      .patchWithSuperAdminToken<AdminLocationRow>(this.locationPath(companyId, locationId), payload)
      .pipe(catchError(error => throwError(() => error)));
  }
}
